import { plural, t } from '@lingui/macro';
export const getLabel = (input) => {
    const { value, type } = input;
    switch (type) {
        case 'approved':
            return t({
                message: plural(value, {
                    one: '#% accepted',
                    other: '#% accepted',
                }),
                comment: 'Plai review progress - legend key - accepted',
            });
        case 'critical':
            return t({
                message: plural(value, {
                    one: '#% critical',
                    other: '#% critical',
                }),
                comment: 'Plai review progress - legend key - critical',
            });
        case 'minor':
            return t({
                message: plural(value, {
                    one: '#% minor',
                    other: '#% minor',
                }),
                comment: 'Plai review progress - legend key - minor',
            });
        case 'notable':
            return t({
                message: plural(value, {
                    one: '#% notable',
                    other: '#% notable',
                }),
                comment: 'Plai review progress - legend key - notable',
            });
        default:
            return null;
    }
};
